import axios from "axios";

const users = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getUsersInfoForFinanceInfo(context, payload) {
            let response = await axios.get(`/get_user_info_for_finance/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getDriversList() {
            let response = await axios.get(`/get_drivers_users`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUsers() {
            let response = await axios.get(`/Users`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFinanceUsers() {
            let response = await axios.get(`/get_finance_user_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUsersManagementList() {
            let response = await axios.get(`/users_management_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUsersByRoles(context, payload) {
            let response = await axios.get(`/get_users_by_roles/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUsersByRolesIfActive(context, payload) {
            let response = await axios.get(`/get_users_by_roles_if_active/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUsersByRolesListIfActive(context, payload){
            let response = await axios.post(`/get_users_by_roles_list_if_active`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },

        async deactiveUser(context, payload) {
            let response = await axios.get(`/deactive_user/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async activeUser(context, payload) {
            let response = await axios.get(`/active_user/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateAdditonalUserInfo(context, payload) {
            let response = await axios.post(`/update_additional_user_info`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setShabaVerify(context, payload){
            let response = await axios.get(`/set_user_shaba_verify/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async syncMobileNo(){
            let response = await axios.get(`/sync_mobile_no`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        }
    },
    getters: {}
}

export default users;
